module.exports = "/images/vendor/flag-icon-css/flags/1x1/sy.svg?73690f50d6d4106fbd4c8ac3a556b985";